var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancelCircleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 12C3 16.963 7.038 21 12 21C16.963 21 21 16.963 21 12C21 7.038 16.963 3 12 3C7.038 3 3 7.038 3 12ZM1 12C1 5.935 5.935 1 12 1C18.065 1 23 5.935 23 12C23 18.065 18.065 23 12 23C5.935 23 1 18.065 1 12ZM14.2928 8.29301C14.6838 7.90201 15.3158 7.90201 15.7068 8.29301C16.0978 8.68401 16.0978 9.31601 15.7068 9.70701L13.4138 12L15.7068 14.293C16.0978 14.684 16.0978 15.316 15.7068 15.707C15.5118 15.902 15.2558 16 14.9998 16C14.7438 16 14.4878 15.902 14.2928 15.707L11.9998 13.414L9.70676 15.707C9.51176 15.902 9.25576 16 8.99976 16C8.74376 16 8.48776 15.902 8.29276 15.707C7.90176 15.316 7.90176 14.684 8.29276 14.293L10.5858 12L8.29276 9.70701C7.90176 9.31601 7.90176 8.68401 8.29276 8.29301C8.68376 7.90201 9.31576 7.90201 9.70676 8.29301L11.9998 10.586L14.2928 8.29301Z",
    fill: "#29173B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelCircleIcon);
export default __webpack_public_path__ + "static/media/cancel-circle-icon.338bfc7b525f8c1e54e61f5c4f305a91.svg";
export { ForwardRef as ReactComponent };